module.exports = function () {
  var html = "\n    <div class=\"combat-overlay\">\n      <div class=\"status\"></div>\n      <div class=\"options\"></div>\n      <div class=\"corps\">\nCorps\n      </div>\n      <div class=\"army\">\nArmy\n      </div>\n      <div class=\"terrain\">\nTerrain\n      </div>\n    </div>\n  ";
  return html;
};